/**
 * Buyer-facing role tags shown at Finish It request time — mirrors the
 * NEED_CHIPS pattern in EngagementPanel, but selects WHO should help
 * rather than WHAT feature is needed.
 *
 * Deliberately multi-select rather than enumerated combos (e.g. no
 * separate "PM + Designer + Developer" option) — the buyer just toggles
 * multiple chips. This is what keeps it from becoming a combinatorial
 * list as roles are added later.
 */
import { CollaboratorRole } from './collaborator.model';

export interface RoleChip {
  key: CollaboratorRole;
  icon: string;
  label: string;
}

export const ROLE_CHIPS: RoleChip[] = [
  { key: 'developer', icon: 'code', label: 'Developer / Coder' },
  { key: 'designer', icon: 'palette', label: 'UI/UX Designer' },
  { key: 'graphic-designer', icon: 'brush', label: 'Graphic Designer' },
  { key: 'pm', icon: 'assignment_ind', label: 'Product Manager' },
];

/** Full label map, including roles not shown as buyer-facing chips (e.g. qa) —
 *  used wherever a role needs to be displayed back (admin screens, etc.). */
export const ROLE_LABEL: Record<CollaboratorRole, string> = {
  developer: 'Developer / Coder',
  designer: 'UI/UX Designer',
  'graphic-designer': 'Graphic Designer',
  qa: 'QA',
  pm: 'Product Manager',
};